import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';

const app = firebase.initializeApp({
  apiKey: 'AIzaSyAps-_4fPlgNtbPf9tKhMyTiNwDCvL316w',
  authDomain: 'cost-divider.firebaseapp.com',
  databaseURL: 'https://cost-divider.firebaseio.com',
  projectId: 'cost-divider',
  storageBucket: 'cost-divider.appspot.com',
  messagingSenderId: '806819605248',
  appId: '1:806819605248:web:feaa27031892d3a2fae1e5'
});

export const db = app.database();
